import { DatoCmsSignUp } from 'lib/datoCms/queries/getAllSignUpLabels';
import { DocumentDataFormLabel } from '../documentData';

export const getDocumentDataLabel = (label: DatoCmsSignUp): DocumentDataFormLabel => {
  return {
    titleDocumentDataFrom: label.titleEighthForm,
    descriptionDocumentDataForm: label.descriptionEighthForm,
    documentType: label.documentType,
    releasedBy: label.releasedBy,
    availableDocuments: label.availableDocuments,
    placeholderDocumentNumber: label.placeholderDocumentNumber,
    labelReleasedBy: label.labelReleasedBy,
    placeholderLocationRelease: label.placeholderLocationRelease,
    releaseDate: label.releaseDate,
    expirationDate: label.expirationDate,
    documentNumber: label.documentNumber,
    locationRelease: label.locationRelease,
  };
};
